import React, { useRef, useState, useEffect } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';
import JoditEditor from 'jodit-react';
import DOMPurify from 'dompurify';
const EmailTemplateModal = ({
  visible,
  onCancel,
  onSuccess,
  api,
  authToken,
  UserData,
  editData
}) => {
  const [name, setName] = useState('');
  const [subject, setSubject] = useState('');
  const [mailBody, setMailBody] = useState('');
  const [loading, setLoading] = useState(false);
  const [templateId, setTemplateId] = useState('');
  const addContactRef = useRef();

  useEffect(() => {
    if (editData) {
      setName(editData.template_id || '');
      setSubject(editData.subject || '');
      const sanitizedHTML = DOMPurify.sanitize(editData.body);
      setMailBody(sanitizedHTML || '');
      setTemplateId(editData.id || '');
    } else {
      setName('');
      setSubject('');
      setMailBody('');
      setTemplateId('');
    }
  }, [editData, visible]);

  const handleSubmit = async () => {
    setLoading(true);
    try {
      let url = editData ? `${api}update-templates` : `${api}store-templates`;
      const payload = { user_id: UserData.id, template_name: name, subject, body: mailBody };
      if (editData) payload.id = templateId;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + authToken,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data.status) {
        message.success(data.message);
        onSuccess();
        onCancel();
      } else {
        message.error(data.message || 'Failed to save template');
      }
    } catch (error) {
      message.error('Error saving template');
    }
    setLoading(false);
  };

  return (
    <Modal
      title={editData ? 'Edit Mail Template' : 'New Mail Template'}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={800}
      style={{ top: 20 }}
      destroyOnClose
    >
      <Form layout="vertical" onFinish={handleSubmit} ref={addContactRef} style={{maxHeight: '80vh', overflowY: 'auto'}}>
        <Form.Item label="Name" className="my-3">
          <Input
            type="text"
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="Your Template Name"
            disabled={!!editData}
          />
        </Form.Item>
        <Form.Item label="Subject" className="my-3">
          <Input
            type="text"
            value={subject}
            onChange={e => setSubject(e.target.value)}
            placeholder="Your Email Subject"
          />
        </Form.Item>
        <label htmlFor="mailBodyEditor" className='mb-2'>Mail Body</label>
          <JoditEditor
            tabIndex={1}
            value={mailBody}
            id="mailBodyEditor"
            onChange={newContent => setMailBody(newContent)}
          />
        <Form.Item label=" " className="my-3">
          <Button type="primary" htmlType="submit" loading={loading}>
            {editData ? 'Update' : 'Submit'}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EmailTemplateModal;
